import { useState, useCallback } from 'react';

type ToastType = 'info' | 'success' | 'error';

interface ToastMessage {
  id: string;
  message: string;
  type: ToastType;
}

// Simple in-memory toast store
let toastListeners: Array<(toast: ToastMessage) => void> = [];
let toastIdCounter = 0;

export const showToast = (message: string, type: ToastType = 'info') => {
  const toast: ToastMessage = {
    id: `toast-${toastIdCounter++}-${Date.now()}`,
    message,
    type
  };
  
  toastListeners.forEach(listener => listener(toast));
};

export const useToast = () => {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const addToast = useCallback((toast: ToastMessage) => {
    setToasts(prev => [...prev, toast]);
    
    // Auto-remove after 5 seconds
    setTimeout(() => {
      removeToast(toast.id);
    }, 5000);
  }, []);

  const removeToast = useCallback((id: string) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  // Subscribe to toast events
  useState(() => {
    toastListeners.push(addToast);
    return () => {
      toastListeners = toastListeners.filter(l => l !== addToast);
    };
  });

  return {
    showToast,
    toasts,
    removeToast
  };
};
